import React, { createContext, useState } from "react";
import { standardsCategoryRows } from "../../StandardsCategoryView/standardsTableMock";

export const DocumentContext = createContext();

export function DocumentProvider({ children }) {
  const [documents, setDocuments] = useState(standardsCategoryRows);

  const updateDocumentName = (id, newName) => {
    setDocuments((prevDocs) =>
      prevDocs.map((doc) =>
        doc.id === id ? { ...doc, name: newName } : doc
      )
    );
  };

  return (
    <DocumentContext.Provider value={{ documents, updateDocumentName }}>
      {children}
    </DocumentContext.Provider>
  );
}
